define('lib/console',['require','exports','module'],function(require, exports, module) {
    "use strict";

    var Console = window.console;

    module.exports = Console;
});
